"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMatches = parseMatches;
exports.hasMinimumSearchText = hasMinimumSearchText;
exports.getAssociatedRecordsFromIds = getAssociatedRecordsFromIds;
exports.getIdsFromOptions = getIdsFromOptions;
exports.getAssociationsFromElasticSearch = getAssociationsFromElasticSearch;
exports.getAssociationsFromAssociationsStore = getAssociationsFromAssociationsStore;

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _ContactsStore = _interopRequireDefault(require("crm_data/contacts/ContactsStore"));

var _CompaniesStore = _interopRequireDefault(require("crm_data/companies/CompaniesStore"));

var _DealsStore = _interopRequireDefault(require("crm_data/deals/DealsStore"));

var _ElasticSearchStore = _interopRequireDefault(require("crm_data/elasticSearch/ElasticSearchStore"));

var _TicketsStore = _interopRequireDefault(require("crm_data/tickets/TicketsStore"));

var _AssociationsStore = _interopRequireDefault(require("crm_data/associations/AssociationsStore"));

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _ElasticSearchValidation = require("crm_data/elasticSearch/ElasticSearchValidation");

var _ElasticSearchConstants = require("customer-data-objects/search/ElasticSearchConstants");

var _immutable = require("immutable");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var getStoreForObjectType = {
  CONTACT: _ContactsStore.default,
  COMPANY: _CompaniesStore.default,
  DEAL: _DealsStore.default,
  TICKET: _TicketsStore.default
};
var getApiResultsKeyForElasticSearch = {
  CONTACT: 'contacts',
  DEAL: 'deals',
  COMPANY: 'companies',
  TICKET: 'results'
};
var ELASTIC_SEARCH_OPTIONS = {
  cacheTimeout: 30000
}; // These functions make calls to various stores
// DO NOT USE THESE FUNCTIONS OUTSIDE OF A DEREF

var getFormattedName = (0, _memoize.default)(function (match, objectType) {
  if (objectType !== _ObjectTypes.CONTACT) {
    return (0, _ImmutableModel.toStringExpanded)(match);
  }

  var firstName = (0, _ImmutableModel.getProperty)(match, 'firstname') || '';
  var lastName = (0, _ImmutableModel.getProperty)(match, 'lastname') || '';
  var email = (0, _ImmutableModel.getProperty)(match, 'email') || '';
  var fullName = (0, _formatName.default)({
    firstName: firstName,
    lastName: lastName
  });

  if (!fullName) {
    return email;
  }

  if (email && email.length) {
    fullName = fullName + " (" + email + ")";
  }

  return fullName;
});

function parseMatches(matches) {
  return matches.filter(_identity.default).map(function (match) {
    var id = (0, _ImmutableModel.getId)(match);
    var objectType = (0, _ImmutableModel.getObjectType)(match);
    return {
      id: id,
      objectType: objectType,
      record: match,
      text: getFormattedName(match, objectType),
      value: objectType + " " + id
    };
  }).sortBy(function (match) {
    return match.text.toLowerCase();
  }).toArray();
}

function hasMinimumSearchText(searchText) {
  var minimumSearchCount = (0, _ElasticSearchValidation.isOfMinSearchLength)(searchText) ? 0 : _ElasticSearchConstants.MIN_SEARCH_LENGTH;
  return searchText.length >= minimumSearchCount;
}

function getAssociatedRecordsFromIds(ids, objectType) {
  if (!ids || !ids.size) {
    return [];
  }

  var store = getStoreForObjectType[objectType];
  var records = store.get(ids).filterNot(function (record) {
    return !record;
  });

  if (!records || !records.size) {
    return _LoadingStatus.LOADING;
  }

  return parseMatches(records);
}

function getIdsFromOptions(values, type) {
  if (!values || !values[type] || !values[type].length) {
    return (0, _immutable.List)();
  }

  var ids = values[type].map(function (value) {
    return Number(value.split(' ')[1]);
  });
  return (0, _immutable.List)(ids);
}

function getAssociationsFromElasticSearch(subjectId, searchQuery, objectType) {
  var resultsKey = getApiResultsKeyForElasticSearch[objectType];

  var associatedIds = _ElasticSearchStore.default.get({
    objectType: objectType,
    searchQuery: searchQuery,
    options: ELASTIC_SEARCH_OPTIONS
  });

  if (!associatedIds) {
    return _LoadingStatus.LOADING;
  }

  var records = associatedIds.get(resultsKey);
  return getAssociatedRecordsFromIds(records, objectType);
}

function getAssociationsFromAssociationsStore(objectType, subjectId, associationType, filterType) {
  // A new/unsaved object with no id by definition has no associations
  if (!subjectId || subjectId === 'null') {
    return [];
  }

  var associatedIds = _AssociationsStore.default.get({
    objectType: objectType,
    objectId: subjectId,
    associationType: associationType
  });

  if (!associatedIds) {
    return _LoadingStatus.LOADING;
  }

  var records = associatedIds.get('results');
  return getAssociatedRecordsFromIds(records, filterType);
}